import { render, staticRenderFns } from "./login.vue?vue&type=template&id=6a0d4c3c&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"
import style0 from "./login.vue?vue&type=style&index=0&id=6a0d4c3c&prod&lang=less&scoped=true"
import style1 from "./login.vue?vue&type=style&index=1&id=6a0d4c3c&prod&lang=less&scoped=true"
import style2 from "./login.vue?vue&type=style&index=2&id=6a0d4c3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d4c3c",
  null
  
)

export default component.exports